import React, {useContext} from 'react'

import Context from '@s-ui/react-context'
import MoleculeNotification, {AUTO_CLOSE, BRDS_SIZE, TYPES} from '@s-ui/react-molecule-notification'

export const Subscribed = () => {
  const {i18n} = useContext(Context)
  const subscribedNotification = i18n.t('NEWSLETTER_SUBSCRIBED')
  const subscribedParagraph = i18n.t('NEWSLETTER_SUBSCRIBED_VERIFY')

  return (
    <>
      <MoleculeNotification
        type={TYPES.success}
        roundedCorners={BRDS_SIZE.medium}
        autoClose={AUTO_CLOSE.manual}
        show
        showCloseButton={false}
      >
        {subscribedNotification}
      </MoleculeNotification>
      {subscribedParagraph}
    </>
  )
}
